import React from 'react'
import {Button, Dialog, DialogActions, DialogContent, DialogTitle} from "@mui/material";

const InformationDialog = ({title, content, open, setOpen}) => {

    return (
        <Dialog
            open={open}
            keepMounted
            onClose={() => setOpen(false)}
            fullWidth={true}
        >
            <DialogTitle>{title}</DialogTitle>
            <DialogContent>
                {content}
            </DialogContent>
            <DialogActions>
                <Button onClick={() => setOpen(false)}>OK</Button>
            </DialogActions>
        </Dialog>
    )
}

export default InformationDialog
